
export const createSection = {
    "createTask": {
        name:'创建稿件',
        type: 'primary',
        conditionFun:(record, currentUser)=>{
            return false
        },

    },
    "receiverTask": {
        name:'创建稿件',
        type: 'primary',
        conditionFun:(record, currentUser)=>{
            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[];
            let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
            if(myRole&&myRole.length&&myRole[0].taskRole.indexOf('文字记者')>-1 && myRole[0].status!=='未领取'&& myRole[0].status!=='已完成'){
                return true
            }else{
                return false
            }
        },
    }
};
